export const BASE_URLs = 'https://apitest.paropakari.com/api/';